<ng-container *ngIf="xsmall$ | async; else common">
  <div class="container-xsmall" [class.active]="active" (click)="click()">
    {{ label }}
  </div>
</ng-container>

<ng-template #common>
  <div class="container">
    <div class="semi-circle" [class.active]="active"></div>
    <div class="container label" [class.active]="active" (click)="click()">
      {{ label }}
    </div>
    <svg
      *ngIf="active"
      width="27"
      height="44"
      viewBox="0 0 27 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M 26.1956 20.4732 L 3.3982 1.1831 C 2.4954 0.4192 1.3511 0 0.1685 0 H 0 V 44 H 0.1685 C 1.3511 44 2.4954 43.5808 3.3982 42.8169 L 26.1956 23.5268 C 27.1398 22.7279 27.1398 21.2721 26.1956 20.4732 Z"
        fill="black"
      />
    </svg>
  </div>
</ng-template>
